import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovRedistributionProps,
    LoadMarkovRedistributionById,
    setMarkovRedistributionEdit,
    setMarkovRedistributionReloadEdit,
    initMarkovRedistribution,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    redistributionId = null,
}: MarkovRedistributionProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const redistribution = useSelector((state: StoreType) => state.markovRedistribution.redistributionEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovRedistribution.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovRedistributionReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovRedistributionReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (redistributionId === 0) {
            dispatch(setMarkovRedistributionEdit(initMarkovRedistribution))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovRedistributionById(redistributionId, model.id).then((res) => {
                dispatch(setMarkovRedistributionEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!redistribution) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{redistribution.id ? `${lang.editRedistribution} # ${redistribution.id}` : lang.addRedistribution}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form redistribution={redistribution} />
                }
                {
                    reloadEdit
                    && <Form redistribution={redistribution} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
